import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import type { CampaignDetail, CampaignsOverview, DealerCampaignDetail } from '../../api/api-types';
import type { Loadable, Loaded } from '../../guards/ngrx-loader.guard';
import { actions } from './campaign.actions';

interface CampaignState {
    campaignsOverview: Loadable<CampaignsOverview>;
    campaignDetail: Loadable<CampaignDetail>;
    dealerCampaignDetail: Loadable<DealerCampaignDetail>;
}

const initialState: CampaignState = {
    campaignsOverview: null,
    campaignDetail: null,
    dealerCampaignDetail: null,
};

export const state = createFeature({
    name: 'campaign',
    reducer: createReducer(
        initialState,
        on(
            actions.loadCampaignOverview,
            (state): CampaignState => ({
                ...state,
                campaignsOverview: null,
            }),
        ),
        on(
            actions.loadCampaignOverviewSuccess,
            (state, { campaignsOverview }): CampaignState => ({
                ...state,
                campaignsOverview,
            }),
        ),
        on(
            actions.loadCampaignOverviewFailure,
            (state): CampaignState => ({
                ...state,
                campaignsOverview: false,
            }),
        ),
        on(
            actions.loadCampaignDetail,
            (state): CampaignState => ({
                ...state,
                campaignDetail: null,
            }),
        ),
        on(
            actions.loadCampaignDetailSuccess,
            (state, { campaign }): CampaignState => ({
                ...state,
                campaignDetail: campaign,
            }),
        ),
        on(
            actions.loadCampaignDetailFailure,
            (state): CampaignState => ({
                ...state,
                campaignDetail: false,
            }),
        ),
        on(
            actions.loadDealerCampaignDetail,
            (state): CampaignState => ({
                ...state,
                dealerCampaignDetail: null,
            }),
        ),
        on(
            actions.loadDealerCampaignDetailSuccess,
            (state, { campaign }): CampaignState => ({
                ...state,
                dealerCampaignDetail: campaign,
            }),
        ),
        on(
            actions.loadDealerCampaignDetailFailure,
            (state): CampaignState => ({
                ...state,
                dealerCampaignDetail: false,
            }),
        ),
    ),
    extraSelectors: (baseSelectors) => {
        const selectIsLoadingCampaignOverview = createSelector(
            baseSelectors.selectCampaignsOverview,
            (campaigns) => campaigns === null,
        );
        const selectLoadedCampaignsOverview = createSelector(
            baseSelectors.selectCampaignsOverview,
            (campaigns) => campaigns as Loaded<CampaignsOverview>,
        );
        const selectIsLoadingcamapignDetail = createSelector(
            baseSelectors.selectCampaignDetail,
            (camapignDetail) => camapignDetail === null,
        );
        const selectLoadedCampaignDetail = createSelector(
            baseSelectors.selectCampaignDetail,
            (camapignDetail) => camapignDetail as Loaded<CampaignDetail>,
        );
        const selectIsLoadingDealerCampaignDetail = createSelector(
            baseSelectors.selectDealerCampaignDetail,
            (dealerCampaignDetail) => dealerCampaignDetail === null,
        );
        const selectLoadedDealerCampaignDetail = createSelector(
            baseSelectors.selectDealerCampaignDetail,
            (dealerCampaignDetail) => dealerCampaignDetail as Loaded<DealerCampaignDetail>,
        );
        return {
            selectIsLoadingCampaignOverview,
            selectLoadedCampaignsOverview,
            selectIsLoadingcamapignDetail,
            selectLoadedCampaignDetail,
            selectIsLoadingDealerCampaignDetail,
            selectLoadedDealerCampaignDetail,
        };
    },
});
